import React from 'react';
import { formatDate } from '../utils/voucherDates';

export default function VoucherShareCard({ voucher, cardRef }) {
  if (!voucher) {
    return null;
  }

  const isActive = voucher.hoursAvailable > 0;

  return (
    <div
      ref={cardRef}
      className="relative overflow-hidden rounded-[34px] border border-[rgba(251,146,60,0.28)] bg-[linear-gradient(135deg,#fffaf0_0%,#fff7ed_42%,#ffffff_100%)] shadow-[0_28px_80px_rgba(249,115,22,0.14)]"
      style={{ width: '100%' }}
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-12 top-10 h-40 w-40 rounded-full bg-orange-300/18 blur-3xl" />
        <div className="absolute right-0 top-0 h-52 w-52 rounded-full bg-amber-300/18 blur-3xl" />
        <div className="absolute bottom-0 right-16 h-40 w-40 rounded-full bg-orange-200/20 blur-3xl" />
      </div>

      <div className="relative border-b border-[rgba(251,191,36,0.22)] bg-gradient-to-r from-orange-500 via-orange-500 to-amber-400 px-7 py-6 text-white">
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-[20px] bg-white/16 text-3xl shadow-[inset_0_1px_0_rgba(255,255,255,0.3)] backdrop-blur-sm">
              🎪
            </div>
            <div>
              <p className="text-[15px] font-bold tracking-[0.03em]">MUNDOLANDIA PARK</p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.42em] text-orange-50/90">Bono de horas</p>
            </div>
          </div>

          <div className="self-start rounded-[24px] border border-white/15 bg-white/18 px-5 py-3 text-left shadow-[inset_0_1px_0_rgba(255,255,255,0.24)] backdrop-blur-md md:min-w-[260px]">
            <p className="text-[10px] uppercase tracking-[0.34em] text-white/76">Código</p>
            <p className="mt-2 text-[22px] font-bold tracking-[0.02em]">{voucher.voucherCode}</p>
          </div>
        </div>
      </div>

      <div className="relative grid gap-6 px-7 py-7 md:grid-cols-[1.5fr_1fr] md:items-stretch">
        <div className="space-y-6">
          <div className="space-y-3">
            <p className="text-[10px] font-medium uppercase tracking-[0.36em] text-slate-400">Titular del bono</p>
            <div className="space-y-3">
              <p className="max-w-[16ch] text-[42px] font-semibold leading-[0.92] tracking-[-0.05em] text-slate-950 md:text-[46px]">
                {voucher.customerName}
              </p>

              <div className="flex flex-wrap gap-3 text-sm text-slate-600">
                {voucher.phone && (
                  <span className="inline-flex items-center gap-2 rounded-full border border-orange-100 bg-white/80 px-3 py-1.5 shadow-[0_6px_18px_rgba(15,23,42,0.04)]">
                    <span className="text-orange-500">📱</span> {voucher.phone}
                  </span>
                )}
                {voucher.email && (
                  <span className="inline-flex items-center gap-2 rounded-full border border-orange-100 bg-white/80 px-3 py-1.5 shadow-[0_6px_18px_rgba(15,23,42,0.04)]">
                    <span className="text-orange-500">✉️</span> {voucher.email}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="grid gap-3 sm:grid-cols-3">
            <div className="rounded-[28px] bg-gradient-to-br from-orange-500 to-amber-400 px-5 py-5 text-white shadow-[0_18px_40px_rgba(249,115,22,0.24)]">
              <p className="text-[10px] uppercase tracking-[0.3em] text-orange-50/84">Disponible</p>
              <p className="mt-3 text-5xl font-bold leading-none tracking-[-0.05em]">{voucher.hoursAvailable}h</p>
            </div>

            <div className="rounded-[28px] border border-slate-200/80 bg-white/76 px-5 py-5 text-slate-900 shadow-[0_10px_26px_rgba(15,23,42,0.04)] backdrop-blur-sm">
              <p className="text-[10px] uppercase tracking-[0.28em] text-slate-400">Compradas</p>
              <p className="mt-3 text-4xl font-semibold leading-none tracking-[-0.04em]">{voucher.hoursPurchased}h</p>
            </div>

            <div className="rounded-[28px] border border-slate-200/80 bg-white/76 px-5 py-5 text-slate-900 shadow-[0_10px_26px_rgba(15,23,42,0.04)] backdrop-blur-sm">
              <p className="text-[10px] uppercase tracking-[0.28em] text-slate-400">Usadas</p>
              <p className="mt-3 text-4xl font-semibold leading-none tracking-[-0.04em]">{voucher.hoursUsed}h</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-between rounded-[30px] border border-[rgba(251,191,36,0.18)] bg-white/60 p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.7),0_12px_28px_rgba(15,23,42,0.04)] backdrop-blur-sm">
          <div>
            <p className="text-[10px] font-medium uppercase tracking-[0.34em] text-slate-400">Validez</p>
            <div className="mt-4 space-y-4">
              <div>
                <p className="text-xs uppercase tracking-[0.22em] text-slate-400">Compra</p>
                <p className="mt-1 text-2xl font-semibold tracking-[-0.03em] text-slate-900">{formatDate(voucher.purchaseDate)}</p>
              </div>
              <div>
                <p className="text-xs uppercase tracking-[0.22em] text-slate-400">Vence</p>
                <p className="mt-1 text-2xl font-semibold tracking-[-0.03em] text-slate-900">{formatDate(voucher.expiresAt)}</p>
              </div>
            </div>
          </div>

          <div className={`mt-6 inline-flex w-fit items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold ${
            isActive
              ? 'border border-emerald-200 bg-emerald-50 text-emerald-700'
              : 'border border-red-200 bg-red-50 text-red-600'
          }`}>
            <span className={`h-2.5 w-2.5 rounded-full ${isActive ? 'bg-emerald-500' : 'bg-red-400'}`} />
            {isActive ? 'Activo' : 'Agotado'}
          </div>
        </div>
      </div>
    </div>
  );
}
